import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { getApi } from "../../services/api/globalApi";
import Pagination from "./../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import Loadning from "./../../components/common/loading/Loading.jsx";
import { FaUsers } from "react-icons/fa";
import PermissionModal from "../../components/common/permission-modal/PermissionModal.jsx";
import UserFilter from "./UserFilter.jsx";
import LoanModal from "../../components/loan/loan-modal/LoanModal.jsx";
import { context } from "../../context/context.js";

const UserList = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState();
  const [showLoading, setShowLoading] = useState(false);

  const { user, utils } = useContext(context);

  const getUser = async (params) => {
    setShowLoading(true);
    const path = "admin/users";
    try {
      const response = await getApi({ path, params: { ...params, limit: 20 } });
      console.log(response?.data);
      setPagination(response?.data);
      setData(response?.data.docs);
      console.log(response?.data.docs);
      setShowLoading(false);
    } catch (error) {
      console.log(error);
      setShowLoading(false);
    }
  };

  useEffect(() => {
    if (user?.role == "admin") {
      getUser({});
    } else {
      filterDataHandler({ page: 1, role: "customer" });
    }
  }, [user]);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getUser(allFilter);
  };

  const navigate = useNavigate();

  const editUser = (item) => {
    navigate(`/edit-user/${item._id}`, { state: item });
  };

  const [userData, setUserData] = useState();

  const userRef = useRef();

  const showModal = (item) => {
    setUserData(item);
    userRef.current.showModal();
  };

  const clearState = () => {
    setUserData();
  };
  const loanRef = useRef();
  const permissionRef = useRef();

  const [userInfo, setUserInfo] = useState(null);

  const addLoan = (item) => {
    setUserInfo(item);
    loanRef.current.showModal();
  };

  const addPermission = (item) => {
    setUserInfo(item);
    permissionRef.current.showModal();
  };

  return (
    <Fragment>
      <LoanModal userData={userInfo} ref={loanRef} />
      {user?.role == "admin" && (
        <PermissionModal
          userData={userInfo}
          ref={permissionRef}
          reGetData={getUser}
        />
      )}
      {/* {showLoading && <Loadning />} */}

      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          // ease: [0, 0.71, 0.2, 1.01]
        }}
        className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6"
      >
        <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
          <FaUsers size={26} />
          لیست کاربران
        </h6>
        <UserFilter filterDataHandler={filterDataHandler} />

        {data?.length > 0 ? (
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    نام
                  </th>
                  <th scope="col" className="px-6 py-3">
                    شماره
                  </th>
                  <th scope="col" className="px-6 py-3">
                    نقش
                  </th>
                  <th scope="col" className="px-6 py-3">
                    وضعیت
                  </th>
                  <th scope="col" className="px-6 py-3">
                    آرشیو
                  </th>
                  <th scope="col" className="px-6 py-3">
                    <span className="sr-only">ویرایش</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    >
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                      >
                        {item.name || "-"}
                      </th>
                      <td className="px-6 py-4">{item.mobile || "-"}</td>
                      <td className="px-6 py-4">
                        {utils?.ROLES?.[item?.role]?.name || "-"}
                      </td>
                      <td className="px-6 py-4">
                        {utils.USER_STATUS?.[item?.status]?.name}
                      </td>
                      <td className="px-6 py-4">
                        {item?.archive == true ? "بله" : "خیر"}
                      </td>
                      <td className="px-6 py-4 text-right flex">
                        <p
                          onClick={() => editUser(item)}
                          className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline"
                        >
                          ویرایش
                        </p>
                        <p
                          onClick={() => addLoan(item)}
                          className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline"
                        >
                          ایجاد وام
                        </p>
                        {user?.role == "admin" && (
                          <p
                            onClick={() => addPermission(item)}
                            className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline"
                          >
                            دسترسی ها
                          </p>
                        )}
                        {/* {item?.archive == false && (
                          <p
                            onClick={() => showModal(item)}
                            className="font-medium cursor-pointer text-red-600 dark:text-blue-500 hover:underline"
                          >
                            آرشیو
                          </p>
                        )} */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="w-full py-2 flex justify-center items-center text-gray-800 dark:text-white">
            شما هنوز هیچ کاربری ثبت نکرده اید
          </p>
        )}
        <div className="mt-6">
          <Pagination
            pagination={pagination}
            filterDataHandler={filterDataHandler}
          />
        </div>
      </motion.div>
    </Fragment>
  );
};

export default UserList;
